const productionOrigin = "https://proximaforma.com";

/** Return a public URL on the deployment currently serving the page. */
export function deploymentUrl(path: `/${string}`) {
  const prerenderOrigin = (globalThis as typeof globalThis & {
    __PROXIMAFORMA_SITE_ORIGIN__?: string;
  }).__PROXIMAFORMA_SITE_ORIGIN__;
  const origin = typeof window === "undefined"
    ? prerenderOrigin || productionOrigin
    : window.location.origin;
  return origin + path;
}
